import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import styles from "./InputCard.module.scss";
import { CSSProperties, PropsWithChildren, ReactNode, useState } from "react";
import { Button } from "antd";
import classNames from 'classnames'

export interface InputCardProps extends PropsWithChildren<{}> {
  title?: ReactNode;
  noBorder?: boolean;
  contained?: boolean;
  className?: string;
  style?: CSSProperties;
  expandable?: boolean;
  onExpand?: () => void;
}

export const InputCard = ({
  children,
  title,
  noBorder,
  contained,
  className,
  style,
  expandable = false,
  onExpand,
}: InputCardProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleExpandClick = () => {
    setIsExpanded((prev) => !prev);
    onExpand?.();
  };

  return (
    <div
      style={style}
      className={classNames(styles["input-card"], className, noBorder ? '' : 'border')}
      data-noborder={noBorder}
      data-contained={contained}
    >
      {title && (
        <div className={[styles["input-title"], "bg-gray py-0"].join(" ")}>
          <span>{title}</span>
          {expandable && (
            <Button
              size="small"
              onClick={handleExpandClick}
              icon={isExpanded ? <MinusOutlined /> : <PlusOutlined />}
              className="mx-2"
            />
          )}
        </div>
      )}
      {children}
    </div>
  );
};
